<mat-form-field class="mat-form-field-language">
  <mat-select id="language-select" [(value)]="selectedLanguage" (selectionChange)="onLanguageChanged()" [disabled]="isActiveSelected">
    <mat-option value="ES">ES</mat-option>
    <mat-option value="PT">PT</mat-option>
    <mat-option value="EN">EN</mat-option>
  </mat-select>
</mat-form-field>
